module.exports = __webpack_public_path__ + "img/z2.dd7689d8.png";